<template>
  <v-navigation-drawer
    v-if="authenticated && $route.name !== 'Login'"
    app
    dark
    width="264"
    class="app-sidebar"
  >
    <div class="app-sidebar__brand">
      <v-avatar size="40" class="app-sidebar__logo">
        <img src="@/assets/jmb_logo.png" alt="JMB Computers" />
      </v-avatar>
      <div class="app-sidebar__brand-text">
        <div class="app-sidebar__brand-name">JMB<span>COMPUTERS</span></div>
        <div class="app-sidebar__brand-tagline">Biometrics Suite</div>
      </div>
    </div>

    <div class="app-sidebar__section-label">Menu</div>

    <v-list nav dense class="app-sidebar__list">
      <v-list-item
        v-for="item in menuItems"
        :key="item.title"
        :to="item.path"
        class="app-sidebar__item"
        active-class="app-sidebar__item--active"
      >
        <v-list-item-icon class="mr-3">
          <v-icon size="20">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="app-sidebar__item-title">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="app-sidebar__footer">
        <v-icon size="14" class="mr-1">mdi-shield-check-outline</v-icon>
        Fast and Reliable Services
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menuItems: [
        {
          title: "Dashboard",
          path: "/dashboard",
          icon: "mdi-view-dashboard-outline",
        },
        {
          title: "Attendance Logs",
          path: "/attendances",
          icon: "mdi-book-open-variant",
        },
        {
          title: "Employees",
          path: "/employees",
          icon: "mdi-account-multiple-outline",
        },

        {
          title: "Departments",
          path: "/departments",
          icon: "mdi-domain",
        },
        {
          title: "Work Schedules",
          path: "/schedules",
          icon: "mdi-clock-outline",
        },
        {
          title: "Leave Credits",
          path: "/leave_credits",
          icon: "mdi-calendar-check-outline",
        },
        {
          title: "Account Information",
          path: "/device_info",
          icon: "mdi-fingerprint",
        },
        {
          title: "Admin Controls",
          path: "/admin_controls",
          icon: "mdi-shield-key-outline",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
  },
};
</script>

<style scoped>
.app-sidebar {
  background: linear-gradient(180deg, #0f172a 0%, #1e1b4b 100%) !important;
  border-right: none !important;
}

.app-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 16px;
}
.app-sidebar__logo {
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.4);
}
.app-sidebar__brand-name {
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #f87171;
}
.app-sidebar__brand-name span {
  color: #818cf8;
}
.app-sidebar__brand-tagline {
  font-size: 0.7rem;
  color: rgba(226, 232, 240, 0.55);
  letter-spacing: 0.04em;
}

.app-sidebar__section-label {
  padding: 8px 20px 4px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(148, 163, 184, 0.7);
}

.app-sidebar__list {
  padding: 4px 12px;
}
.app-sidebar__item {
  border-radius: 10px !important;
  margin-bottom: 4px;
  color: rgba(203, 213, 225, 0.85) !important;
  transition: background-color 0.2s ease, color 0.2s ease,
    transform 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}
.app-sidebar__item:hover {
  background: rgba(99, 102, 241, 0.12);
  transform: translateX(2px);
}
.app-sidebar__item--active {
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
}
.app-sidebar__item--active::before {
  opacity: 0 !important;
}
.app-sidebar__item-title {
  font-size: 0.82rem !important;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.app-sidebar__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 16px;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  color: rgba(148, 163, 184, 0.7);
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}
</style>
